import React, {createContext, useContext, useMemo} from 'react';
import {Col, Dropdown, Row, Tooltip} from "antd";
import {MoreOutlined} from "@ant-design/icons";

const TableMenuContext = createContext({})

export const useTableMenuContext = () => useContext(TableMenuContext)
const TableMenu = ({mode, items, length = 3, children, restRowClassName, ...rest}) => {

    const data = useMemo(() => {
        return items?.filter(item => !!item) || []
    }, [items])

    return (
        data?.length > length ? <Dropdown
            menu={{items}}
            trigger={['click']}
        >
            <MoreOutlined className="text-lg text-[#344054]"/>
        </Dropdown> : (
            <>
                <TableMenuContext.Provider value={{mode}}>
                    <Row gutter={16} className={`justify-end ${restRowClassName}`}>
                        {children ? children : (

                            data?.map((item, index) => {

                                return <Col onClick={() => item?.onClick && item?.onClick()}
                                            key={index}
                                            className={"cursor-pointer"}>
                                    {(!!item?.icon || !!item?.originalIcon) && (item?.hint ? <Tooltip title={item.hint}>
                                        {React.cloneElement(item?.icon || item?.originalIcon, {className: "text-lg text-[#344054]"})}
                                    </Tooltip> : React.cloneElement(item?.icon || item?.originalIcon, {className: "text-lg text-[#344054]"}))}
                                </Col>
                            })
                        )}

                    </Row>
                </TableMenuContext.Provider>

            </>
        )
    );
};

TableMenu.propTypes = {};

export default TableMenu;